import templateUrl from "servicestack/app-releases/app-releases-container.htm";
import controller from "servicestack/app-releases/app-releases-container.controller";

export default {
  bindings: {
    simple: "<?",
    detailRoute: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
